import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, Mail, MapPin } from "lucide-react";

export default function About() {
  return (
    <div className="bg-stone-950" data-testid="about-page">
      <section className="py-24 lg:py-32">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="label-eyebrow mb-3">About</div>
          <h1 className="font-display text-5xl sm:text-6xl font-black text-stone-50 tracking-tight">
            Oz is part of a last name.
            <br />
            <span className="text-yellow-400">Odds is part of the work.</span>
          </h1>
          <div className="mt-10 grid md:grid-cols-5 gap-12">
            <div className="md:col-span-3 space-y-6 text-stone-300 leading-relaxed text-lg">
              <p>
                Oz and Ends LLC is a small Wisconsin operation built on a
                simple idea: the work doesn't have to be glamorous to be done
                right. Storms knock things down. Garages fill up. Estates need
                clearing. Hedges grow wild. Somebody has to handle it — and
                doing it well is its own kind of craft.
              </p>
              <p>
                The name's a bit of a wink. "Oz" is half of a last name. "Odds
                and Ends" is what the day usually looks like. And yeah —
                there's a yellow brick road in there too, because hard jobs
                always feel a little better when there's a clear path home.
              </p>
              <p className="text-yellow-300 font-display italic text-2xl pt-4 border-t border-stone-800">
                "There's no place like home — let us take care of it."
              </p>
            </div>
            <aside className="md:col-span-2 border border-stone-800 bg-stone-900 p-8 h-fit">
              <div className="label-eyebrow mb-4">Contact</div>
              <ul className="space-y-4 text-stone-200">
                <li className="flex items-start gap-3">
                  <Phone className="h-5 w-5 text-yellow-400 mt-0.5" />
                  <a href="tel:7152146563" className="hover:text-yellow-300">
                    715-214-6563
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <Mail className="h-5 w-5 text-yellow-400 mt-0.5" />
                  <a
                    href="mailto:oz@ozends.com"
                    className="hover:text-yellow-300 break-all"
                  >
                    oz@ozends.com
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 text-yellow-400 mt-0.5" />
                  <span>
                    Eau Claire, WI
                    <br />
                    <span className="text-stone-400 text-sm">
                      Travel by approved inquiry
                    </span>
                  </span>
                </li>
              </ul>
              <Link
                to="/book"
                data-testid="about-book-btn"
                className="mt-8 inline-flex items-center gap-2 bg-yellow-500 text-yellow-950 font-bold uppercase tracking-wider px-5 py-3 border-2 border-yellow-500 hover:bg-yellow-400 w-full justify-center"
              >
                Start a Job <ArrowRight className="h-4 w-4" />
              </Link>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}
